import React from "react";
import { Link } from "react-router-dom";

const Bio = (props) => {
  return (
    <>
      <section id="bio">
        <h2>Bio</h2>
        <div className="cajaBio">
          <div>
            <img
              className="imgRedonda floatLeft wow animate__animated animate__flipInY animate__delay-1s"
              src="/index/bio.png"
              alt="Arte naturalista. Obras y procesos."
            />
          </div>
          <p>
            Me gradué de Licenciada en Bellas Artes en la UNR y me especialicé
            en Estudios Irlandeses en la USAL.
          </p>
          <p>
            Mi práctica contemporánea explora vínculos entre arte y naturaleza a
            través de la cerámica, la instalación, la fotografía analógica y
            procesos sensibles de investigación situada.
          </p>
          <p>
            Todo mi trabajo y mi vida está atravesado por los materiales y los
            tiempos de la naturaleza y pensado también para generar el menor
            impacto negativo posible en el ambiente.
          </p>

          <p>
            Actualmente desarrollo mi obra y facilito espacios de producción.
            También llevo adelante el proyecto "Revelar con plantas".{" "}
          </p>
        </div>

        <Link
          to="#statement"
          className=""
          onClick={() => props.handleScrollTo("#statement")}
        >
          <div className="flecha">¡</div>
        </Link>
      </section>
    </>
  );
};

export default Bio;
